import { useLang } from '@/i18n/LanguageContext';
import MaskLines from '@/components/MaskLines';

export default function Why() {
  const { t } = useLang();
  const w = t.why;
  return (
    <section id="why" className="px-5 py-[20vh] md:px-10 md:py-[24vh]" data-testid="section-why">
      <p className="mb-10 font-mono-label text-[var(--pz-green)]">{w.kicker}</p>
      <h2 className="font-display text-[10vw] leading-[0.88] md:text-[7vw]">
        <MaskLines lines={w.lines} />
        <span className="text-stroke">
          <MaskLines lines={w.extra} delay={0.2} />
        </span>
      </h2>
      <div className="mt-14 max-w-2xl space-y-5 text-base text-white/70 md:text-lg">
        <p>{w.body}</p>
        <p className="font-display pt-4 text-2xl leading-[1] text-white md:text-4xl">
          {/* tre righe: domanda / risposta / percentuale (solo il numero in verde) */}
          <span className="block">{w.goal[0]}</span>
          <span className="block">{w.goal[1]}</span>
          <span className="block xl:whitespace-nowrap">
            {w.goal[2][0]}
            <span className="text-[var(--pz-green)]">{w.goal[2][1]}</span>
            {w.goal[2][2]}
          </span>
        </p>
        <p>{w.note}</p>
      </div>
    </section>
  );
}
